module.exports = __webpack_public_path__ + "img/upload-image.2e9106d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/upload-image.png
// module id = g2z2
// module chunks = 39 44